import React, { useEffect, useRef } from "react";
import { SaveFilterPopupProps } from '../interFaces/interfaces';
import "../css/others/Popup.css";
const SaveFilterPopup: React.FC<SaveFilterPopupProps> = ({ isOpen, filterName, setFilterName, togglePopup, onSave, }) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  useEffect(() => {
    if (isOpen && inputRef.current) { inputRef.current.focus(); }
  }, [isOpen]);
  useEffect(() => {
    const handleFocusOut = (event: FocusEvent) => {
      if (isOpen && inputRef.current && !inputRef.current.contains(event.target as Node)) { inputRef.current.focus(); }
    };
    if (isOpen) { document.addEventListener("focusin", handleFocusOut); }
    return () => { document.removeEventListener("focusin", handleFocusOut); };
  }, [isOpen]);
  if (!isOpen) return null;
  return (
    <div className="popup-overlay">
      <div className="popup-favorite-filter">
        <h3>Enter Favorite Filter Name</h3>
        <input ref={inputRef} type="text" placeholder="Enter favorite filter name" value={filterName} onChange={(e) => setFilterName(e.target.value)} />
        <div className="popup-buttons">
          <button className="popup-close-btn" onClick={togglePopup}>Close</button>
          <button className={`popup-submit-btn ${!filterName.trim() ? "btn-disabled-look" : ""}`} onClick={onSave}>Save</button>
        </div>
      </div>
    </div>
  );
};
export default SaveFilterPopup;